import React from 'react';

interface Props {
  name: string;
  style?: React.CSSProperties;
}

export const Icon: React.FC<Props> = ({ name, style }) => {
  switch (name) {
    case 'chevron-right':
      return (
        <svg
          style={style}
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="chevron-right"
          role="img"
          aria-label="Chevron right"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 320 512"
        >
          <path
            fill="currentColor"
            d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
          ></path>
        </svg>
      );
    case 'chevron-left':
      return (
        <svg
          style={style}
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="chevron-left"
          role="img"
          aria-label="Chevron left"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 320 512"
        >
          <path
            fill="currentColor"
            d="M7,201.35,201.37,7.05a23.9,23.9,0,0,1,33.9,0L258,29.75a23.9,23.9,0,0,1,0,33.9L104,218.35l154,154.7a24.08,24.08,0,0,1,0,33.9l-22.7,22.7a23.9,23.9,0,0,1-33.9,0L7,235.35A24.22,24.22,0,0,1,7,201.35Z"
          />
        </svg>
      );
    case 'chevron-down':
      return (
        <svg
          style={style}
          aria-hidden="true"
          focusable="false"
          data-prefix="far"
          data-icon="chevron-down"
          role="img"
          aria-label="Chevron down"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path
            fill="currentColor"
            d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"
          ></path>
        </svg>
      );
    case 'chevron-up':
      return (
        <svg
          style={style}
          aria-hidden="true"
          focusable="false"
          data-prefix="far"
          data-icon="chevron-up"
          role="img"
          aria-label="Chevron up"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path
            fill="currentColor"
            d="M6.101 359.293L25.9 379.092c4.686 4.686 12.284 4.686 16.971 0L224 198.393l181.13 180.698c4.686 4.686 12.284 4.686 16.971 0l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L232.485 132.908c-4.686-4.686-12.284-4.686-16.971 0L6.101 342.322c-4.687 4.687-4.687 12.285 0 16.971z"
          ></path>
        </svg>
      );
    case 'close':
      return (
        <svg
          style={style}
          aria-hidden="true"
          focusable="false"
          data-prefix="fal"
          data-icon="times"
          role="img"
          aria-label="Close"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 320 512"
        >
          <path
            fill="currentColor"
            d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"
          ></path>
        </svg>
      );
    case 'lock':
      return (
        <svg style={style} aria-hidden="true" focusable="false" role="img" aria-label="Lock" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path
            fill="currentColor"
            d="M96 192V128C96 57.31 153.3 0 224 0C294.7 0 352 57.31 352 128V192H368C412.2 192 448 227.8 448 272V432C448 476.2 412.2 512 368 512H80C35.82 512 0 476.2 0 432V272C0 227.8 35.82 192 80 192H96zM128 192H320V128C320 74.98 277 32 224 32C170.1 32 128 74.98 128 128V192zM32 432C32 458.5 53.49 480 80 480H368C394.5 480 416 458.5 416 432V272C416 245.5 394.5 224 368 224H80C53.49 224 32 245.5 32 272V432z"
          />
        </svg>
      );
    case 'badge-percent':
      return (
        <svg style={style} aria-hidden="true" focusable="false" role="img" aria-label="Percent" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            fill="currentColor"
            d="M224 192C224 209.7 209.7 224 192 224C174.3 224 160 209.7 160 192C160 174.3 174.3 160 192 160C209.7 160 224 174.3 224 192zM192 176C183.2 176 176 183.2 176 192C176 200.8 183.2 208 192 208C200.8 208 208 200.8 208 192C208 183.2 200.8 176 192 176zM288 320C288 302.3 302.3 288 320 288C337.7 288 352 302.3 352 320C352 337.7 337.7 352 320 352C302.3 352 288 337.7 288 320zM320 336C328.8 336 336 328.8 336 320C336 311.2 328.8 304 320 304C311.2 304 304 311.2 304 320C304 328.8 311.2 336 320 336zM181.7 341.7C178.5 344.8 173.5 344.8 170.3 341.7C167.2 338.5 167.2 333.5 170.3 330.3L330.3 170.3C333.5 167.2 338.5 167.2 341.7 170.3C344.8 173.5 344.8 178.5 341.7 181.7L181.7 341.7zM342.1 48.16C375.1 40.3 411.3 49.22 437 74.98C462.8 100.7 471.7 136.9 463.8 169.9C492.7 187.7 512 219.6 512 256C512 292.4 492.7 324.3 463.8 342.1C471.7 375.1 462.8 411.3 437 437C411.3 462.8 375.1 471.7 342.1 463.8C324.3 492.7 292.4 512 256 512C219.6 512 187.7 492.7 169.9 463.8C136.9 471.7 100.7 462.8 74.98 437C49.23 411.3 40.3 375.1 48.16 342.1C19.28 324.3 0 292.4 0 256C0 219.6 19.28 187.7 48.16 169.9C40.3 136.9 49.23 100.7 74.98 74.98C100.7 49.23 136.9 40.3 169.9 48.16C187.7 19.28 219.6 0 256 0C292.4 0 324.3 19.28 342.1 48.16H342.1zM177.8 67.09L171.4 65.15C142.3 56.2 109.3 63.26 86.29 86.29C63.26 109.3 56.2 142.3 65.15 171.4L67.09 177.8L61.25 180.8C34.32 195.1 16 223.4 16 255.1C16 288.6 34.32 316.9 61.25 331.2L67.09 334.2L65.15 340.6C56.2 369.7 63.26 402.7 86.29 425.7C109.3 448.7 142.3 455.8 171.4 446.9L177.8 444.9L180.8 450.8C195.1 477.7 223.4 496 256 496C288.6 496 316.9 477.7 331.2 450.8L334.2 444.9L340.6 446.9C369.7 455.8 402.7 448.7 425.7 425.7C448.7 402.7 455.8 369.7 446.9 340.6L444.9 334.2L450.8 331.2C477.7 316.9 496 288.6 496 255.1C496 223.4 477.7 195.1 450.8 180.8L444.9 177.8L446.9 171.4C455.8 142.3 448.7 109.3 425.7 86.29C402.7 63.26 369.7 56.2 340.6 65.15L334.2 67.09L331.2 61.25C316.9 34.32 288.6 15.1 256 15.1C223.4 15.1 195.1 34.32 180.8 61.25L177.8 67.09z"
          />
        </svg>
      );
    case 'info':
      return (
        <svg style={style} aria-hidden="true" focusable="false" role="img" aria-label="Info" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 480c-123.5 0-224-100.5-224-224s100.5-224 224-224s224 100.5 224 224S379.5 480 256 480zM256 184c13.25 0 24-10.74 24-24c0-13.25-10.75-24-24-24S232 146.7 232 160C232 173.3 242.7 184 256 184zM304 352h-32V240C272 231.2 264.8 224 256 224H224C215.2 224 208 231.2 208 240S215.2 256 224 256h16v96h-32C199.2 352 192 359.2 192 368C192 376.8 199.2 384 208 384h96c8.836 0 16-7.164 16-16C320 359.2 312.8 352 304 352z" />
        </svg>
      );
    case 'phone':
      return (
        <svg style={style} focusable="false" role="img" aria-label="Phone" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            fill="currentColor"
            d="M18.92 351.2l108.5-46.52c12.78-5.531 27.77-1.801 36.45 8.98l44.09 53.82c69.25-34 125.5-90.31 159.5-159.5l-53.81-44.04c-10.75-8.781-14.41-23.69-8.974-36.47l46.51-108.5c6.094-13.91 21.1-21.52 35.79-18.11l100.8 23.25c14.25 3.25 24.22 15.8 24.22 30.46c0 252.3-205.2 457.5-457.5 457.5c-14.67 0-27.18-9.968-30.45-24.22l-23.25-100.8C-2.571 372.4 5.018 357.2 18.92 351.2z"
          />
        </svg>
      );
    default:
      return <></>;
  }
};

export default Icon;
